/* global axios */
import ApiClient from './ApiClient';

class CommunicationConnection extends ApiClient {
  constructor() {
    super('communication_connection', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(params) {
    return axios.post(this.url, { communication_connection: params });
  }

  update(params) {
    return axios.patch(this.url, { communication_connection: params });
  }

  delete() {
    return axios.delete(this.url);
  }

  testConnection() {
    return axios.post(`${this.url}/test_connection`);
  }

  fetchAccounts() {
    return axios.get(`${this.url}/accounts`);
  }

  fetchHealth() {
    return axios.get(`${this.url}/health`);
  }

  bind({ gatewayAccountId, inboxName }) {
    return axios.post(`${this.url}/bindings`, {
      gateway_account_id: gatewayAccountId,
      inbox_name: inboxName,
    });
  }

  rebind({ channelId, gatewayAccountId }) {
    return axios.patch(`${this.url}/bindings/${channelId}`, {
      gateway_account_id: gatewayAccountId,
    });
  }

  fetchSummary() {
    return axios.get(`${this.url}/summary`);
  }
}

export default new CommunicationConnection();
